export enum HttpType {
    post,
    get,
    delete,
    put,
}

export enum PopupType {
    none,
    selectSimilarProvider,
    providerManagementEditPopup,
    providerNewProviderWorkerPopup,
    providerProviderWorkerEditPopup,
    plantDetailsPopup,
    importPlantsPopup,
    importUsersPopup,
    formReportFilterPopup,
    formReportChangeOwnerPopup,
    addOrUpdatePlantPopup,
    addOrUpdateUserPopup,
    editGlobalSettingsPopup
}

export enum ErrorType {
    warning,
    error,
}

export enum ErrorLocationType {
    none,
    login,
    popup,
    table,
    form,
    account
}

export enum PreferenceType {
    filter = 1,
    hiddenColumn = 2,
    general = 3,
    columnOrder
}

export enum SsoType {
    none,
    oauth,
    saml
}

export enum TableType {
    form,
    user,
    plant,
    settings,
    provider,
    providerWorkers,
    similarCompany
}

export enum UsersType{
    anab,
    anv
}
